import AWS from "aws-sdk";
import { cognitoConfig } from "../config";
import * as cognito from "./cognito";
import axios from "axios";

AWS.config.region = cognitoConfig.Region;

const Bucket = "ctie.kashiwa.web";
const ConfigKey = "config/frontConfig.json";

const createS3 = async () => {
  const credentials = await cognito.getCredentials();
  return new AWS.S3({
    credentials: credentials,
    region: cognitoConfig.Region
  });
};

export const getFrontConfig = async () => {
  try {
    const url = await getSignedUrl(ConfigKey);
    const response = await axios
      .create({
        responseType: "json"
      })
      .get(`${url}&timestamp=${new Date().getTime()}`);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const putFrontConfig = async data => {
  const s3 = await createS3();
  const requestParams = {
    Bucket: Bucket,
    Key: ConfigKey,
    Body: JSON.stringify(data)
  };
  const res = await s3.putObject(requestParams).promise();
  return res.$response.httpResponse;
};

export const getSignedUrl = async key => {
  const s3 = await createS3();
  const res = await s3.getSignedUrlPromise("getObject", {
    Bucket: Bucket,
    Key: key,
    Expires: 60
  });
  return res;
};
